"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE32_DIGITS_MAP = exports.BASE32_DIGITS = exports.LONGITUDE_MAX_VALUE = exports.LATITUDE_MAX_VALUE = exports.BASE32_BITS_PER_CHAR = exports.MAX_BIT_DEPTH = exports.MIN_BIT_DEPTH = exports.BASE32_HASH_MAX_LENGTH = exports.BASE32_HASH_MIN_LENGTH = void 0;
exports.BASE32_HASH_MIN_LENGTH = 1;
exports.BASE32_HASH_MAX_LENGTH = 9;
exports.MIN_BIT_DEPTH = 1;
exports.MAX_BIT_DEPTH = 52;
exports.BASE32_BITS_PER_CHAR = 5;
exports.LATITUDE_MAX_VALUE = 90;
exports.LONGITUDE_MAX_VALUE = 180;
exports.BASE32_DIGITS = Array.from('0123456789bcdefghjkmnpqrstuvwxyz');
exports.BASE32_DIGITS_MAP = new Map(exports.BASE32_DIGITS.map(function (digit, i) { return [digit, i]; }));
